// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__QDDt3","block":"Footer_block__KmqyT","info":"Footer_info__qt1UC"};